export function getPath(firstKey, secondKey, lastKey){
  const firstKeyNormalize = firstKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "-");
  const secondKeyNormalize = secondKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "-");
  const lastKeyNormalize = lastKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "-");

  const url = ('/' + firstKeyNormalize + '/' + secondKeyNormalize + '/' + lastKeyNormalize).toLowerCase();
  return url;
}